"use client";
import { IBlocks } from "@/types";
import React from "react";
import { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import { Skeleton } from "@/components/ui/skeleton";

interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
}
export default function BlockTidal({ edit, block, update }: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    const parts = blockUpdate.url
        .replace("/browse", "") // remove 'browse'
        .split("?")[0] // remove query params
        .split("/"); // split into segments
    const type = parts[parts.length - 2];
    const id = parts[parts.length - 1];
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={`Tidal - ${blockUpdate.url}`}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            {type && id ? (
                <iframe
                    id="tidal"
                    style={{ borderRadius: "12px" }}
                    src={`https://embed.tidal.com/${type}s/${id}?disableAnalytics=true`}
                    width="100%"
                    height={
                        type === "album" || type === "playlist" ? "300" : "152"
                    }
                    frameBorder="0"
                    allowFullScreen={false}
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                    className={"block-" + block.id}
                />
            ) : (
                <TidalSkeleton />
            )}
        </AdminPopover>
    );
}

function TidalSkeleton({ height = 152 }: { height?: number }) {
    return (
        <div
            className="flex items-center gap-4 bg-black/20 p-2"
            style={{ height, borderRadius: "12px" }}
        >
            <Skeleton
                className="flex-shrink-0 rounded-md"
                style={{ width: height, height }}
            />
            <div className="flex flex-1 flex-col gap-2 self-start">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-1/2" />
            </div>
        </div>
    );
}
